import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
// Copyright 1999-2019. Plesk International GmbH. All rights reserved.
import classNames from 'classnames';
import React from 'react';
import { CLS_PREFIX } from '../../constants';
import Icon from '../Icon';

var MultiValue = function MultiValue(_ref) {
  var _ref$baseClassName = _ref.baseClassName,
      baseClassName = _ref$baseClassName === void 0 ? "".concat(CLS_PREFIX, "select-multi-value") : _ref$baseClassName,
      onRemove = _ref.onRemove,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["baseClassName", "onRemove", "children"]);

  var onMouseDown = function onMouseDown(e) {
    e.preventDefault();
  };

  var onClick = function onClick(e) {
    e.stopPropagation();
    onRemove();
  };

  return React.createElement("div", _extends({
    className: classNames(baseClassName)
  }, props), React.createElement("div", {
    className: "".concat(baseClassName, "__content")
  }, React.createElement("span", {
    className: "".concat(baseClassName, "__label")
  }, children), React.createElement(Icon, {
    className: "".concat(baseClassName, "__remove"),
    size: "12",
    onMouseDown: onMouseDown,
    onClick: onClick
  }, React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    focusable: "false",
    "aria-hidden": "true"
  }, React.createElement("path", {
    d: "M3.85 8.854a.498.498 0 1 1-.704-.704L5.296 6l-2.15-2.15a.498.498 0 0 1 .704-.704L6 5.296l2.15-2.15a.498.498 0 1 1 .704.704L6.704 6l2.15 2.15a.498.498 0 0 1-.704.704L6 6.704l-2.15 2.15z"
  })))));
};

export default MultiValue;